import { UIList } from '@/components/ui/List';
import { UIBox } from '@/components/ui/Box';
import styled from 'styled-components';

export const GridRecapStyles = `
  grid-template-columns: repeat(2, minmax(300px, 1fr));
`;

export const StyledUIList = styled(UIList)`
  min-width: 700px;
  width: 100%;
  h1 {
    width: 100%;
    align-items: flex-start;
    padding: 0 24px;
    display: grid;
    ${GridRecapStyles}
  }
`;

export const StyledColumn = styled(UIBox)`
  display: flex;
  flex-direction: column;
`;
export const StyledHeader = styled(UIBox)``;
export const StyledContent = styled(UIBox)``;
